export class InputUtils {
    constructor() {

    }


    static onlyNumbersWhole(event: any): boolean {

        const key = event.keyCode || event.which;
        const tecla = String.fromCharCode(key);
        const numeros = "0123456789";

        const regexp: RegExp = new RegExp(/^(0|[1-9]\d*)$/);
        const val: string = event.target.value + tecla;

        if (numeros.indexOf(tecla) === -1 || regexp.test(val) === false) {
            return false;
        }
        return true;
    }

    static onlyNumbers(event: any): boolean {

        const key = event.keyCode || event.which;
        const tecla = String.fromCharCode(key);
        const numeros = "0123456789.";

        const regexp: RegExp = new RegExp(/^\d+\.?\d{0,2}$/);
        const val: string = event.target.value + tecla;

        if (numeros.indexOf(tecla) === -1 || regexp.test(val) === false) {
            return false;
        }
        return true;
    }
}